import React from 'react'
import { Link } from 'react-router-dom'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../AppInsights';

class PageNotFound extends React.Component {
    render() {
        return (
            <div>
                    <aside className="main_content">
                        <p >Sorry!! This url doesn't exist</p>
                        <Link to="/">Go to Home </Link>
                  </aside>
            </div>
        )
    }
}

export default withAITracking(reactPlugin, PageNotFound)